import currency from "../masks/currency";

function validate(value: number, minValue?: number | null, maxValue?: number | null) {
  if (typeof minValue === "number" && value < minValue) return false;
  if (typeof maxValue === "number" && value > maxValue) return false;

  return true;
}

function getErrorMessage(minValue?: number | null, maxValue?: number | null): string {
  const hasMin = typeof minValue === 'number';
  const hasMax = typeof maxValue === 'number';

  if (hasMin && hasMax) {
    return `O valor deve estar entre R$ ${currency.mask(minValue * 100)} e R$ ${currency.mask(maxValue * 100)}.`;
  }

  if (hasMin) {
    return `O valor deve ser maior ou igual a R$ ${currency.mask(minValue * 100)}.`;
  }

  if (hasMax) {
    return `O valor deve ser menor ou igual a R$ ${currency.mask(maxValue * 100)}.`;
  }

  return "";
}


const currencyValidator = {
  validate,
  getErrorMessage,
}

export default currencyValidator;
